import { UseFormRegister } from "react-hook-form";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { dateFormatUtcToYMD1 } from "src/utils/dateManagement";
import dayjs from "dayjs";
import styles from "./CheckPromotion.module.scss";
import { CheckPromotionFormData } from "./CheckPromotion.schema";
import { useTranslation } from "react-i18next";
import { mindsatServiceNameMap } from "src/config/config";

interface IPromotionInfoProps {
  checkPromotionCodeV2Res: any;
  register: UseFormRegister<CheckPromotionFormData>;
}

const PromotionInfo = ({
  checkPromotionCodeV2Res,
  register,
}: IPromotionInfoProps) => {
  const { t } = useTranslation();
  if (!checkPromotionCodeV2Res) return null;

  return (
    <div className={`${styles.resultContainer}`}>
      <div className={styles.detailBox}>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>
            {t("siteType.premium.detail.plan.expirationDate")}
          </span>
          <div className={styles.detailValue}>
            {checkPromotionCodeV2Res.subscriptionEndDate ? (
              <>
                {dateFormatUtcToYMD1(
                  checkPromotionCodeV2Res.subscriptionEndDate
                )}
                (
                {t("siteType.premium.detail.plan.days", {
                  0: dayjs(checkPromotionCodeV2Res.subscriptionEndDate).diff(
                    dayjs(),
                    "days"
                  ),
                })}
                )
              </>
            ) : (
              "-"
            )}
          </div>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>
            {t("siteType.premium.detail.plan.userNum")}
          </span>
          <div className={styles.detailValue}>
            {t("siteType.premium.detail.plan.person", {
              0: checkPromotionCodeV2Res.licenseCount,
            })}
          </div>
        </div>
        {getProductFromSessionStorage() === "WRAPSODY_ECO" && (
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>
              {t("siteType.premium.detail.plan.userExtenalInvite")}
            </span>
            <div className={styles.detailValue}>
              {t("siteType.premium.detail.plan.person", {
                0: checkPromotionCodeV2Res.externalLicenseCount,
              })}
            </div>
          </div>
        )}
        {!["DSP", "DSPM", "MIND_SAT"].includes(
          getProductFromSessionStorage()
        ) && (
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>
              {t("siteManagement.createSite.detail.storage.fieldname")}(
              {t("siteManagement.createSite.detail.storage.byteUnit")})
            </span>
            <div className={styles.detailValue}>
              {checkPromotionCodeV2Res.totalStorage}
            </div>
          </div>
        )}
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>
            {t("cashStatus.pay.totalPrice")}
          </span>
          <div className={styles.detailValue}>
            {checkPromotionCodeV2Res?.totalPrice}
          </div>
        </div>
        {checkPromotionCodeV2Res?.nxacAppList && (
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>
              {t("common.application")}
            </span>
            <div className={styles.detailValue}>
              {checkPromotionCodeV2Res?.nxacAppList?.map(
                (app: any, index: number) => {
                  return (
                    <span key={index}>
                      {index !== 0 && ", "}
                      {app.name}
                    </span>
                  );
                }
              )}
            </div>
          </div>
        )}
        {checkPromotionCodeV2Res?.referralId && (
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>
              {t("siteType.referralId")}
            </span>
            <div className={styles.detailValue}>
              <input
                type="text"
                {...register("referralId")}
                className={styles.detailInput}
              />
            </div>
          </div>
        )}
        {checkPromotionCodeV2Res?.drmPackageInfo && (
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Drm Package</span>
            <div className={styles.detailValue}>
              {checkPromotionCodeV2Res?.drmPackageInfo?.packageDescription}(
              {checkPromotionCodeV2Res?.drmPackageInfo?.products?.map(
                (product: any, index: number) => {
                  return (
                    <span key={index}>
                      {index !== 0 && ", "}
                      {product}
                    </span>
                  );
                }
              )}
              )
            </div>
          </div>
        )}
        {checkPromotionCodeV2Res?.mindsatServiceList && (
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>
              {t("siteType.premium.mindsat.paidservice.title")}
            </span>
            <div className={styles.detailValue}>
              {checkPromotionCodeV2Res?.mindsatServiceList?.map(
                (
                  service: keyof typeof mindsatServiceNameMap,
                  index: number
                ) => {
                  return (
                    <span key={index}>{`${t(mindsatServiceNameMap[service])}${
                      index !==
                      checkPromotionCodeV2Res?.mindsatServiceList?.length - 1
                        ? ", "
                        : ""
                    }`}</span>
                  );
                }
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PromotionInfo;
